import axios from "axios";
import { getAxiosConfigWithToken } from "../helpers/functions_helper"
import * as url from "../helpers/url_helper"

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class TaskStatusService {
    async getTaskStatus(DATA: any) {
        const response = await axios
            .get(SERVER_URL + url.GET_TASK_STATUS + "/" + DATA.id + "/" + DATA.task_status_id,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async getTaskStatusList(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.GET_TASK_STATUS_LIST, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            );
        return response;
    }

    async createTaskStatus(DATA: any) {
        const response = await axios
            .put(SERVER_URL + url.CREATE_TASK_STATUS, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async updateTaskStatus(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.UPDATE_TASK_STATUS, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }

    async deleteTaskStatus(DATA: any) {
        const response = await axios
            .post(SERVER_URL + url.DELETE_TASK_STATUS, DATA,
                {
                    headers: getAxiosConfigWithToken()
                }
            ).then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error;
            });
            return response;
    }
}

export default new TaskStatusService();